<template lang="pug">
.IndustryLibraryList
  .list_item(v-for="(item, i) in listNew", :key="i")
    .list_item_content
      router-link.item_title(
        :to="{ name: 'crisisDetails', query: { id: item.id } }",
        target="_blank"
      ) {{ item.eventName }}
      .time_tags
        .time {{ item.startTime }}
        .tag {{ item.priCrisisTags[0] }}
      .infos
        .info(v-for="(item, i) in item.infoList", :key="i")
          .title {{ item.name }}：
          .value {{ item.value }}
  NoData(v-if="listNew.length === 0")
</template>

<script>
import moment from 'moment'
import NoData from '../components/NoData.vue'
export default {
  components: { NoData },
  props: {
    list: Array
  },
  data () {
    return {
    }
  },
  computed: {
    listNew () {
      return this.list.map(t => {
        return {
          ...t,
          startTime: t.startTime ? moment(t.startTime).format('YYYY-MM-DD') : '--',
          infoList: [
            {
              name: '涉事企业',
              value: t.priBrand || '--'
            },
            {
              name: '风险等级',
              value: t.crisisLevelZh || '--'
            },
            {
              name: '行业/领域',
              value: t.industryAndField || '--'
            },
            {
              name: '次生舆情',
              value: t.secondaryCount || '--'
            }
          ]
        }
      })
    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.IndustryLibraryList {
  margin-top: 24px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  .list_item {
    width: 33.33%;
    padding-right: 20px;
    padding-bottom: 20px;
    &:nth-child(3n) {
      padding-right: 0;
    }
    .list_item_content {
      border-radius: 4px;
      background-color: #ffffff;
      padding: 24px 20px;
      .item_title {
        font-size: 16px;
        color: #333333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &:hover {
          color: #3989cb;
        }
      }
      .time_tags {
        margin-top: 24px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .time {
          font-size: 12px;
          color: #444444;
        }
        .tag {
          padding: 0 10px;
          height: 24px;
          line-height: 24px;
          border-radius: 2px;
          text-align: center;
          color: #f77950;
          background-color: #fef1ed;
        }
      }
      .infos {
        padding: 12px 17px 1px 12px;
        margin-top: 22px;
        background-color: #f8f8f8;
        border-radius: 5px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .info {
          max-width: 100%;
          font-size: 12px;
          color: #666;
          margin-bottom: 12px;
          display: flex;

          // 左边
          &:nth-child(odd) {
            width: 70%;
          }

          // 右边
          &:nth-child(even) {
            flex: 1;
          }

          .title {
            min-width: 60px;
            color: #666666;
          }

          .value {
            flex: 1;
            color: #444;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/EventIndex/HomePage/RiskLibrary/RiskLibraryList.vue